export default function initSelectTitleObserver() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;

  const selector = '.ant-select-item-option-content, .ant-select-item, .ant-select-selection-item, .ant-select-selection-item-content';

  const setTitles = (root = document.body) => {
    if (!root || !root.querySelectorAll) return;
    const nodes = root.querySelectorAll(selector);
    nodes.forEach((n) => {
      const text = n.textContent?.trim();
      if (text && n.title !== text) n.title = text;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTitles());
  } else {
    setTitles();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((n) => {
          if (n.nodeType === 1) setTitles(n);
        });
      }
    });
  });

  try {
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (e) {
  }

  return observer;
}
